export default __webpack_public_path__ + "static/media/login.5913c84c.svg";